import "core-js/stable";
import "regenerator-runtime/runtime";

import React from "react";
import { createRoot } from "react-dom/client";
import LoginModule from "./src/Login/Module";

const container = document.getElementById("flow-login-module");
const root = createRoot(container);
root.render(<LoginModule />);
